<template>
  <div style="background-color: white">
  <div>
    <van-nav-bar title="审核列表" style="position:fixed;width: 100%;"  @click-left="onClickLeft" left-text="返回" left-arrow>
    </van-nav-bar>
    <div  style="padding-top: 45px">
      <div v-if="ht">
          <kp :ht="ht"></kp>
          <van-button v-if="ht.status==1 && dqlc == 1" round type="info" @click="shshow=true" block>审批</van-button>
      </div>

    </div>
  </div>
        <van-action-sheet v-model="shshow" title="标题">
          <div class="content">
               <van-cell-group>
            <van-radio-group v-model="form.shzt" direction="horizontal">

              <van-radio name="1" style="width: 50%;">通过</van-radio>
              <van-radio name="0">驳回</van-radio>
            </van-radio-group>
               </van-cell-group>
               <van-cell title="审核意见"></van-cell>
            <van-cell-group>
              <van-field
               v-model="form.shyj"
               rows="4"
               autosize

               type="textarea"
               placeholder="可输入审核意见" />
            </van-cell-group>
            <van-button round type="info" @click="sptj" block>确定</van-button>
          </div>
        </van-action-sheet>
  </div>
</template>

<script>
// import {DictTag} from "@/components/DictTag/index"

import kp from '../Zsmb/kp.vue'
export default {
  name: 'kpsh',
  components: {
    kp: kp
  },
  data () {
    return {
      ht: null,
      dict: {type: []},
      dicts: ['xm_htjd', 'xm_hzxz', 'xm_yes_no', 'xm_htfjsx', 'xm_wtdw', 'xm_xsht_lx'],
      dataid: null,
      workid: null,
      dqlc: null,
      depts: [],
      shshow: false,
      loading: false,
      form: {
        dataid: null,
        shzt: 1,
        shyj: ''
      }

    }
  },
  created () {
    //  console.log("this",this.$route.query)
    this.dataid = this.$route.query.dataid
    this.workid = this.$route.query.workid
    this.dqlc = this.$route.query.dqlc
    this.getdepts()
    this.getdicts()
    this.getHt()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    kssp () {},
    getdepts () {
      let that = this
      this.$ajax.get('/system/dept/list').then(res => {
        that.depts = res.data
      })
    },
    getdicts () {
      let that = this
      if (this.dicts.length > 0) {
        for (let d of this.dicts) {
          // console.log("d",d)
          this.$ajax.get('/system/dict/data/type/' + d).then(res => {
            that.dict.type[d] = res.data
            //  console.log(that.dict)
          })
        }
      }
    },
    getHt () {
      let that = this
      this.$ajax.get('/xm/htkp/' + this.workid).then(function (res) {
        if (res.code == 200) {
          that.ht = res.data
          console.log('that.ht', res.data)
        }
      })
    },

    sptj () {
      this.form.dataid = this.dataid
      this.form.workid = this.workid
      this.$ajax.post('/xm/htkp/shlc', this.form).then(res => {
        if (res.code == 200) {
          this.$toast.success('审核完成')
          this.$router.go(-1)
        }
      })
    }

  }
}

</script>

<style  lang="scss" scoped>
  // 底部标签栏
  .van-tabbar{
  .van-tabbar-item{
  &.van-tabbar-item--active{
     color: #1989fa !important;
   }
  &:first-child,&:last-child{
                   color: #1989fa;
                   background-color: #ECEDFD;//rgba(1, 1, 1, .6)//#DFE0E6;
  .van-tabbar-item__icon{
    font-size: 1rem;
  }
  }
  &:nth-child(2){
     color: #fff;
     background-color: #1989fa;
  &.van-tabbar-item--active{
     color: #fff !important;
   }
  }
  }
  }
 .content {
    padding: 16px 16px 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ShenHe/kpsh.vue